import React from 'react';
import Heading from '../../../../shared/components/Heading';
import Stack from '../../../../shared/spa/core-components/Stack/Stack';
import Inline from '../../../../shared/spa/core-components/Inline/Inline';

export interface StatsProps {
    icon: React.ReactNode;
    title: string;
    description: React.ReactNode;
}

const StatsItem = ({ icon, title, description }: StatsProps) => (
    <Stack space="space4">
        <Inline space="space6">
            {icon}
            <Heading type="h3" variations={['h3', 'no-margin']}>
                <span>{title}</span>
            </Heading>
        </Inline>

        <div>{description}</div>
    </Stack>
);

export default StatsItem;
